import { render, staticRenderFns } from "./PtGrid.vue?vue&type=template&id=781a4818&scoped=true"
import script from "./PtGrid.vue?vue&type=script&lang=js"
export * from "./PtGrid.vue?vue&type=script&lang=js"
import style0 from "./PtGrid.vue?vue&type=style&index=0&id=781a4818&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "781a4818",
  null
  
)

export default component.exports